import 'styles/application';
import 'javascripts/application';
require.context('../', true, /\.(png|jpg|jpeg|svg|webp)$/);